module.exports = __webpack_public_path__ + "img/logo.3f77406a.png";